import { useRouter } from 'next/router';

import Pagination from '@mui/material/Pagination';

import Spinner from '@core/components/spinner/Spinner';
import ReviewCard from './ReviewCard';

import classes from './ReviewsList.module.scss';

const ReviewsList = ({ reviews, count, pageSize, isLoading }) => {
	const router = useRouter();

	const currentPage = router.query.page ? Number(router.query.page) : 1;
	const totalPages = count ? Math.ceil(count / pageSize) : 0;

	const handlePageChange = (_event, value) => {
		router.replace(
			{
				pathname: router.pathname,
				query: { ...router.query, page: value }
			},
			undefined,
			{ shallow: true }
		);
	};

	return (
		<section className={classes['reviews']}>
			<h2 className={classes['heading']}>Learner Reviews</h2>

			{isLoading ? (
				<div className={classes['loading']}>
					<Spinner />
				</div>
			) : reviews?.length ? (
				<div className={classes['grid']}>
					{reviews.map((review) => (
						<ReviewCard key={review.id} review={review} />
					))}
				</div>
			) : (
				<p className={classes['empty']}>No reviews to show yet.</p>
			)}

			{totalPages > 1 && (
				<div className={classes['pagination']}>
					<Pagination
						variant="outlined"
						shape="rounded"
						color="primary"
						count={totalPages}
						page={currentPage}
						onChange={handlePageChange}
					/>
				</div>
			)}
		</section>
	);
};

export default ReviewsList;
